import CollabModal from './CollabModal';

export default CollabModal;
